import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4079e165")

_pushScopeId("data-v-4079e165")
const _hoisted_1 = { class: "py-20 pl-16" }
const _hoisted_2 = { class: "df-middle" }
const _hoisted_3 = { class: "d-f box" }
const _hoisted_4 = { class: "user__asset pt-20 pr-16" }
const _hoisted_5 = { class: "mt-24 d-f" }
const _hoisted_6 = {
  class: "flex-1 scroll-y list",
  style: {"height":"262px"}
}
const _hoisted_7 = { class: "df-middle ml-16 mb-8" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TheFirstDepositCard = _resolveComponent("TheFirstDepositCard")
  const _component_AccountRelated = _resolveComponent("AccountRelated")
  const _component_t = _resolveComponent("t")
  const _component_TheAsset = _resolveComponent("TheAsset")
  const _component_PositionBarWithBadge = _resolveComponent("PositionBarWithBadge")
  const _component_CommissionBarWithBadge = _resolveComponent("CommissionBarWithBadge")
  const _component_Positions = _resolveComponent("Positions")
  const _component_TheCommissions = _resolveComponent("TheCommissions")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("button", {
        class: ['switch', !_ctx.isDemoAccount && 'active'],
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.useDemo(false)))
      }, " Live account ", 2),
      _createVNode(_component_AccountRelated, { "use-in-real": "" }, {
        default: _withId(() => [
          _createVNode(_component_TheFirstDepositCard)
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_TheAsset, null, {
          default: _withId(() => [
            _createVNode(_component_AccountRelated, { "use-in-real": "" }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_5, [
                  _createVNode("button", {
                    class: "flex-3 btn line sm out br-sm ml-10",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goSpeed('1-1', true)))
                  }, [
                    _createVNode(_component_t, {
                      path: "trade_11",
                      custom: ""
                    }, {
                      default: _withId(({td}) => [
                        _createTextVNode(_toDisplayString(td || 'Withdrawal'), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode("button", {
                    class: "flex-5 btn success sm mx-10 br-sm",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goSpeed('1-0', true)))
                  }, [
                    _createVNode(_component_t, {
                      path: "trade_12",
                      custom: ""
                    }, {
                      default: _withId(({td}) => [
                        _createTextVNode(_toDisplayString(td || 'Deposit'), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode("div", {
            class: ["change-item toggle__line-btn anchor", { active: _ctx.active === _ctx.OrderType.position }],
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changeClick && _ctx.changeClick(...args)))
          }, [
            _createVNode(_component_PositionBarWithBadge)
          ], 2),
          _createVNode("div", {
            class: ["change-item toggle__line-btn anchor", { active: _ctx.active === _ctx.OrderType.commissions }],
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.changeClick && _ctx.changeClick(...args)))
          }, [
            _createVNode(_component_CommissionBarWithBadge)
          ], 2)
        ]),
        _withDirectives(_createVNode(_component_Positions, null, null, 512), [
          [_vShow, _ctx.active === _ctx.OrderType.position]
        ]),
        (_ctx.active === _ctx.OrderType.commissions)
          ? (_openBlock(), _createBlock(_component_TheCommissions, { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
})